module.exports = __webpack_public_path__ + "media/images/home/flow_r_1-958c2173b6387b509fdf1525437d2145.svg";